import { FC } from 'react';
import { IconProps } from './types';

const StackingIcon: FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.342"
      height="53.785"
      viewBox="0 0 44.342 53.785"
      className={className}
    >
      <path
        data-name="Union 43"
        d="M.665 52.785A.661.661 0 0 1 0 52.129V30.895a.639.639 0 0 1 .244-.495l.081-.068-.019-.021 18.736-16.229.086-.074-.084-.077a3.369 3.369 0 0 1-1.11-2.4h1.329a2.139 2.139 0 0 0 2.126 2 2.288 2.288 0 0 0 .524-.062 2.1 2.1 0 0 0-.1-4.111 1.356 1.356 0 0 1-1.083-1.324v-2.74h-2.1V0h5.359v5.294h-1.931v2.781l.081.018a3.4 3.4 0 0 1 2.654 4 3.355 3.355 0 0 1-.961 1.76l-.079.078 19.282 16.38-.019.023.08.066a.638.638 0 0 1 .248.5v21.229a.661.661 0 0 1-.664.656zm.664-1.312h40.686V31.551H1.33zM2.4 30.238h38.513L22.6 14.684l-.045-.038-.056.019-.071.025a1.955 1.955 0 0 1-.207.064 3.574 3.574 0 0 1-.828.1 3.5 3.5 0 0 1-.981-.149l-.055-.016zM19.961 3.981h2.7V1.313h-2.7zm20 45.456H38.7v-15.85h1.268v15.849zm-2.524 0h-1.263v-15.85h1.268v15.849zm-2.523 0h-1.262v-15.85h1.268v15.849zm-2.524 0h-1.262v-15.85H32.4v15.849zm-2.523 0h-1.262v-15.85h1.268v15.849zm-2.524 0h-1.262v-15.85h1.268v15.849zm-2.523 0h-1.261v-15.85h1.268v15.849zm-2.522 0h-1.261v-15.85H22.3v15.849zm-2.523 0h-1.261v-15.85h1.268v15.849zm-2.524 0H15.99v-15.85h1.268v15.849zm-2.523 0h-1.26v-15.85h1.268v15.849zm-2.523 0h-1.26v-15.85h1.268v15.849zm-2.523 0h-1.26v-15.85H9.69v15.849zm-2.524 0H5.9v-15.85h1.266v15.849zm-2.523 0H3.376v-15.85h1.268v15.849z"
        transform="translate(.499 .5)"
        style={{ fill: '#4780bf', stroke: 'transparent', strokeMiterlimit: 10 }}
      />
    </svg>
  );
};

export default StackingIcon;
